import breakpoints from './breakpoints';

const media = {
    mobile320: `@media screen and (min-width: ${breakpoints.mobile320})`,
    mobile481: `@media screen and (min-width: ${breakpoints.mobile481})`,
    tablet648: `@media screen and (min-width: ${breakpoints.tablet648})`,
    tablet720: `@media screen and (min-width: ${breakpoints.tablet720})`,
    tablet937: `@media screen and (min-width: ${breakpoints.tablet937})`,
    tablet1080: `@media screen and (min-width: ${breakpoints.tablet1080})`,
    desktop1224: `@media screen and (min-width: ${breakpoints.desktop1224})`,
    desktop1296: `@media screen and (min-width: ${breakpoints.desktop1296})`,
    desktop1352: `@media screen and (min-width: ${breakpoints.desktop1352})`,
    desktop1440: `@media screen and (min-width: ${breakpoints.desktop1440})`,
    desktop1920: `@media screen and (min-width: ${breakpoints.desktop1920})`,
    retina1352: `@media screen and (min-width: ${breakpoints.desktop1352}) and (-webkit-min-device-pixel-ratio: 2), screen and (${breakpoints.desktop1352}) and (min-resolution: 192dpi)`,
};

export default media;
